YUI.add('event-list', function (Y) {

    "use strict";

    var $ = Y.one,
        HOST = "host",
        DOT = ".",
        UL = "ul",
        SIDEBAR_SECONDARY_CLASS = "ksu-sidebar-secondary",
        ACTIVE_CLASS = "ksu-active",
        LOADING_HIDDEN_CLASS = "ksu-loading-hidden",
        IMAGE_ATTR = "data-image",
        DATA_LOAD_ATTR = "data-load",
        HREF = "href",
        history,
        templateEngine,
        today_YYYYMMDD,
        basedate,         // The date the calendar starts on.
        RECURRING_EVENTS_TITLE = "Recurring events",
        TRANSITION_DURATION = 0.4,
        CONTENT_TRANSITIONING_CLASS = "ksu-transitioning",
        CONTENT_CLOSED_CLASS = "ksu-closed",
        CONTENT_OPEN_CLASS = "ksu-open",

        /*
         * Constants used as attribute names used to store information on this plugin instance.
         * There is one constant here for each attribute defined in the EventList.ATTRS property.
         */
        AUDIENCE_ATTR = "audience",
        BASEURL_ATTR = "baseurl",
        CALENDAR_ATTR = "calendar",
        CALENDAR_NAV_WIDGET_KEY = "calendarnavwidget",
        CALENDAR_URL_KEY = "calendarurl",
        DATA_ATTR = "data",
        DATE_HEADER_ATTR = "dateheader",
        DAYS_ATTR = "days",
        END_ATTR = "end",
        EVENT_ID_ATTR = "eventid",
        EXCLUDE_TYPE_ATTR = "excludetype",
        EXCLUDE_TITLE_ATTR = "excludetitle",
        INCLUDE_TITLE_ATTR = "includetitle",
        FILTER_ATTR = "filter",
        GROUPBY_KEY = "groupby",
        HOSTNAME_ATTR = "hostname",
        LIMIT_ATTR = "limit",
        HEADER_NAV_ATTR = "headernav",
        IMAGE_BASE_URL_ATTR = "imagebaseurl",    // Delete once v3 is universal.  V3 includes the complete URL.
        INCLUDEPRIVATE_ATTR = "includeprivate",
        ROLLUPRECURRING_KEY = "rolluprecurring",
        SIDEBAR_CALENDAR_KEY = "sidebarcalendar",
        SINGLE_EVENT_ATTR = "singleevent",
        SORT_ORDER_ATTR = "sortorder",
        START_ATTR = "start",
        TEMPLATE_ATTR = "template",
        TITLE_KEY = "title",
        TYPE_ATTR = "type",
        UNIQUE_ATTR = "unique",
        VENUE_ATTR = "venue",
        SEPARATOR = "&thinsp;&ndash;&thinsp;",
        LOADING_HTML = "Loading...",

        /*
         * Templates are fed an object with three levels of nesting.
         *
         * The top-level object represents the event list itself, and has the following properties:
         *
         *     title -- a string.  If not null, this is used as the title of the event list
         *     calendarurl -- a string used as a URL.  If not null, the title is linked to this URL,
         *        and a footer is added with "See all events" linked to this URL.
         *
         *
         *
         *    groups -- an array, one entry for each group of events
         *
         *
         * If "group-by" is not truthy, then there is only one entry in the groups array.
         * If "group-by" is "day", then there is one entry in the groups array per day.
         * Each entry in the groups array is itself an array, with one entry per event.
         *
         */

        /*
         * The EVENT_ITEM_TEMPLATE is used to format a single event's LI element.
         * No header, footer, or other decoration is included in this template,
         * including the OL element that this list item must be nested within.
         */
        EVENT_ITEM_TEMPLATE =
            "<li itemscope itemtype='http://www.schema.org/Event'" +
                // "<% console.log('event', event); %>" +
                "<% if (event.friendly.image) { %> class='ksu-el-with-img' <% } %>>" +
                "<% if (event.friendly.image) { %>" +
                    "<img class='ksu-el-img' src='<%= event.friendly.image %>' width='80' height='80'>" +
                "<% } %>" +
                "<div class='ksu-el-content'>" +
                    "<div class='ksu-el-hd'>" +
                        "<div class='ksu-el-time'>" +
                            "<time itemprop='startDate' datetime='<%= event.start_date %>T<%= event.start_time %>'><%= event.friendly.start_datetime %></time><%== event.friendly.datetime_sep %>" +
                            "<time itemprop='endDate' datetime='<%= event.end_date %>T<%= event.end_time %>'><%= event.friendly.end_datetime %></time>" +
                        "</div>" +
                        "<h6 itemprop='name' class='ksu-el-title'><a itemprop='url' href='<%= event.friendly.url %>' data-ksu-eventid='<%= event.id %>' data-ksu-event-startdate='<%= event.start_date %>'><%= event.title %></a></h6>" +
                        "<h6 class='ksu-el-category'>" +
                            "<%== event.friendly.types %><%== event.friendly.types_sponsors_sep %><%== event.friendly.sponsors %>" +
                        "</h6>" +

                        "<% if (event.friendly.venues) { %>" +
                            "<div itemprop='location' itemscope itemtype='http://schema.org/Place'>" +
                                "<div itemprop='name'><%== event.friendly.venues %></div>" +
                            "</div>" +
                        "<% } %>" +
                    "</div>" +

                    "<div" +
                        "<% if (!event.singleevent) { %> class='ksu-more-container-arrow ksu-bg-f8'<% } %>>" +
                        "<div class='ksu-el-desc-container'><div itemprop='description'><%== event.description %></div></div>" +
                        "<% if (event.url) { %>" +
                            "<div>For more information, visit the <a href='<%= event.url %>'>event website</a>.</div>" +
                        "<% } %>" +
                        "<% if (event.cost) { %>" +
                            "<div><b>Cost:</b> <%= event.cost %></div>" +
                        "<% } %>" +
                        "<% if (event.friendly.contacts) { %>" +
                            "<div><b>Contact:</b> " +
                            "<% Y.Array.each(event.friendly.contacts, function (line) { %>" +
                                "<%== line %>" +
                            "<% }); %>" +
                            "</div>" +
                        "<% } %>" +
                        "<% if (event.friendly.types) { %>" +
                            "<div><b>Event type:</b> <%= event.friendly.types %></div>" +
                        "<% } %>" +
                        "<% if (event.friendly.sponsors) { %>" +
                            "<div><b>Sponsor:</b> <%== event.friendly.sponsors %></div>" +
                        "<% } %>" +
                    "</div>" +

                    "<div class='ksu-el-ft'>" +
                        "<div class='ksu-el-ft-datetime'>" +
                            "<span class='ksu-el-bd-datetime'><%= event.friendly.start_datetime %><%== event.friendly.datetime_sep %></span><span class='ksu-el-bd-date'><%= event.friendly.start_date %><%== event.friendly.date_sep %></span><span class='ksu-el-bd-time'><%= event.friendly.start_time %><%== event.friendly.time_sep %></span>" +
                            "<span class='ksu-el-bd-datetime'><%= event.friendly.end_datetime %></span><span class='ksu-el-bd-date'><%= event.friendly.end_date %></span><span class='ksu-el-bd-time'><%= event.friendly.end_time %></span><%== event.friendly.datetime_venue_sep %>" +
                        "</div>" +
                        "<% if (event.friendly.venues) { %>" +
                            "<div itemprop='location' itemscope itemtype='http://schema.org/Place'>" +
                               "<div itemprop='name'><%== event.friendly.venues %></div>" +
                            "</div>" +
                        "<% } %>" +
                    "</div>" +
                "</div>" +
            "</li>",

               SINGLE_EVENT_TEMPLATE =
                   "<section class='ksu-el-container'>" +

                   "<ol class='ksu-el-events'>" +

                       "<% var event = this; %>" +
                       EVENT_ITEM_TEMPLATE +

                   "</ol>" +
                "</section>",

               RECURRING_LABEL_TEMPLATE =
                "<% if (data.hidden) { %>" +
                    "+ Show <% } else { %>- Hide <% } %>" +
                "<%= data.count %> recurring events",


        /*
         * The top-level template.   This template is used for the outermost container
         * of an event list.
         *
         * The template processor takes this string and an object that represents the event list itself.
         * The object has the following properties:
         *
         *     title -- a string.  If not null, this is used as the title of the event list
         *     calendarurl -- a string used as a URL.  If not null, the title is linked to this URL,
         *        and a footer is added with "See all events" linked to this URL.
         *     groups -- an array, one entry for each group of events
         *
         *
         * If "group-by" attrubute of the is not truthy, then there is only one entry in the groups array.
         * If "group-by" is "day", then there is one entry in the groups array per day.
         * Each entry in the groups array is itself an array, with one entry per event.

         */
        TEMPLATE =
            "<section class='ksu-el-container" +
                       "<% if (this.dateheader) { %>" +
                         " ksu-el-with-dateheader" +
                       "<% } %>" +
                   "'>" +
           "<% if (this.title) { %>" +
                   "<h4><%== this.title %></h4>" +
           "<% } %>" +

               "<% if (this.headernav.type) { %>" +
                       "<div class='ksu-el-nav'>" +
                           "<div class='ksu-prev'></div>" +
                           "<h4><%= this.headernav.label %></h4>" +
                           "<div class='ksu-next'></div>" +
                       "</div>" +
               "<% } %>" +

//               "<% if (this.dayheader) { %>" +
//                           "<h5><%= this.dayheader.title %></h5>" +
//               "<% } %>" +


               "<% Y.Array.each(this.groups, function (eventgroup) { %>" +
                   "<div class='ksu-el-ghd'>" +
                   "<% if (eventgroup.title) { %>" +
                     "<h5><%== eventgroup.title %></h5>" +
                     "<h5 class='ksu-el-date-abbr'><%== eventgroup.titleabbr %></h5>" +
                     "<% if (eventgroup.title === '" + RECURRING_EVENTS_TITLE + "') { %>" +
                         "<a class='ksu-el-toggle-recurring'>+ Show " + // TODO -- reused the above template
                             "<%= eventgroup.length %> recurring events</a>" +
                     "<% } %>" +
                   "<% } %>" +
                   "</div>" +

                   "<div class='ksu-el-gbd" +
                      "<% if (eventgroup.title === '" + RECURRING_EVENTS_TITLE + "') { %>" +
                          " ksu-closed' style='height: 0px;" +
                      "<% } %>" +
                   "'>" +
           "<ol class='ksu-el-events'>" +
                   "<% Y.Array.each(eventgroup, function (event) { %>" +

                       EVENT_ITEM_TEMPLATE +

                   "<% }); %>" +

           "</ol>" +
                   "</div>" +
               "<% }); %>" +
                   "<% if (this.calendarurl) { %>" +
                       "<a href='<%= this.calendarurl %>'>See all events</a>" +
                   "<% } %>" +
                "</section>";


    /*
     * Private methods
     */
    var padLeft = function(s, n, c) {

        s = s.toString();             // Convert s into a string
        c = (c || "0").toString();    // Use the specified pad character, defaulting to "0", and convert to a string.

        while (s.length < n) {
            s = c + s;           // Because both s and c are strings, this will always be string concatenation, never addition.
        }

        return s.substr(0, n);
    };

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function(searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    var parseYYYYMMDD = function(yyyymmdd) {

        var jsdate = null, match, yyyy, mm, dd;

        /* Some browsers, such as Chrome, assume a timezone of +00:00 for converting ISO8601 dates.  So I just
         * do the long-way for now.
         */
        //      try {
        //         jsdate = new Date(yyyymmdd+"T00:00:00");
        //      } catch (e) {
        //         /* Nothing, leave jsdata as null. */
        //      }

        if (!jsdate || !jsdate.getTime()) {
            match = /^(\d\d\d\d)-?(\d\d)-?(\d\d)$/.exec(yyyymmdd);
            if (match) {
                yyyy = parseInt(match[1], 10);
                mm = parseInt(match[2], 10);
                dd = parseInt(match[3], 10);

                jsdate = new Date(yyyy, mm-1, dd);
            }
        }

        return jsdate;
    };


    var getYYYYMMDD = function(date) {

        return padLeft(date.getFullYear(),4) + '-' + padLeft(date.getMonth()+1,2) + '-' + padLeft(date.getDate(),2);

    };


    var getToday = function() {
        var now;

        now = new Date();

        return getYYYYMMDD(now);
    };


    var buildURL = function(url, proxy, thisplugin) {

        var calendar = thisplugin.get(CALENDAR_ATTR),
            audience = thisplugin.get(AUDIENCE_ATTR),
            days,
            end      = thisplugin.get(END_ATTR),
            eventid  = thisplugin.get(EVENT_ID_ATTR),
            excludetitle = thisplugin.get(EXCLUDE_TITLE_ATTR),
            includetitle = thisplugin.get(INCLUDE_TITLE_ATTR),
            excludetype  = thisplugin.get(EXCLUDE_TYPE_ATTR),
            filter   = thisplugin.get(FILTER_ATTR),
            limit    = thisplugin.get(LIMIT_ATTR),
            start    = thisplugin.get(START_ATTR),
            type     = thisplugin.get(TYPE_ATTR),
            venue    = thisplugin.get(VENUE_ATTR),
            jsstart, jsend;


        if (!url) {
            url = thisplugin.get(HOSTNAME_ATTR) + thisplugin.get(BASEURL_ATTR);
        }

        if (eventid) {
            url += "?format=jsonp" + "&id=" + eventid +
                   "&start=" + (start || '20100101').replace(/-/g, '') +    // If no start/end available, use a wide range.
                   "&end=" + (end || '20410930').replace(/-/g, '') +        // My 80th birthday, if I'm lucky.  :-)
                   "&callback=" + proxy;
            return url;
        }

        url += "?format=jsonp";

        /*
         * If an end date is not specified, calculate the end by the day count.
         */
        if (!end) {
            days = thisplugin.get(DAYS_ATTR);
            jsstart = parseYYYYMMDD(start);
            jsend = new Date(jsstart.getTime() + (days-1)*24*60*60*1000);
            end = getYYYYMMDD(jsend);
        }

        url += "&start=" + start.replace(/-/g, '') + "&end=" + end.replace(/-/g, '');

        if (calendar) {
            url += "&area_slugs=" + calendar;
        }

        if (audience) {
            url += "&audience_slugs=" + audience;
        }

        if (limit) {
            if (filter || excludetype || includetitle || excludetitle) {
               limit = Math.max(2 * limit, 20);   // Because of filtering, have to retrieve more events
            }
            url += "&limit=" + limit;
        }

        if (type) {
            url += "&type_slugs=" + type;
        }

        if (venue) {
            url += "&venue_slugs=" + venue;
        }

        url = url + "&callback=" + proxy;

        return url;

    };


    var humanizeTime = function(hhmmss) {

        var hh, mm, ss, am, result, match,
            replacetimes = {"12:00:00": "noon", "00:00:00": "midnight"};

        if (!hhmmss) {
            return "";
        }

        if (hhmmss in replacetimes) {
            return replacetimes[hhmmss];
        }

        result = hhmmss;

        match = /^(\d\d)(:\d\d)(:\d\d)$/.exec(hhmmss);
        if (match) {
            hh = parseInt(match[1], 10);
            mm = match[2];
            ss = match[3];
            am = hh < 12;
            if (hh > 12) {
                hh = hh - 12;
            }

            if (ss===':00') {
                ss = "";

                if (mm===':00') {
                    mm = "";
                }
            }

            result = hh + mm + ss + (am ? " a.m." : " p.m.");
        }

        return result;

    };


    var humanizeDate = function(yyyymmdd, full) {

        var result = "", jsdate, now = new Date(), format;

        try {
            jsdate = parseYYYYMMDD(yyyymmdd);
            if (full) {
                format = "%A, %B %e, %Y";
            } else if (jsdate.getYear() === now.getYear()) {
                format = "%b %e";
            } else {
                format = "%b %e, %Y";
            }

            result = Y.DataType.Date.format(jsdate, {format: format});

        } catch(err) {
            console.log("Exception in humanizeDate", err);
            /* Nothing, leave result as "". */
        }

        return result;
    };


    var ascendingDate = function(a, b) {

        var aval, bval;

        aval = a.recurring || false;
        bval = b.recurring || false;
        if (aval > bval) {
            return -1;
        }
        if (aval < bval) {
            return 1;
        }

        aval = a.priority || 0;
        bval = b.priority || 0;
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        aval = a.recurring_start_date || "";
        bval = b.recurring_start_date || "";
        if (aval > bval) {
            return -1;
        }
        if (aval < bval) {
            return 1;
        }

        aval = a.start_date || "";
        bval = b.start_date || "";
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        aval = a.start_time || "";
        bval = b.start_time || "";
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        aval = a.end_date || "";
        bval = b.end_date || "";
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        aval = a.end_time || "";
        bval = b.end_time || "";
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        try {
            aval = a.venue.name || "";
        } catch(ex) {
            aval = "";
        }
        try {
            bval = b.venue.name || "";
        } catch(ex) {
            bval = "";
        }
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        aval = a.title || "";
        bval = b.title || "";
        if (aval < bval) {
            return -1;
        }
        if (aval > bval) {
            return 1;
        }

        return 0;

    };


    var descendingDate = function(a, b) {

        return -ascendingDate(a, b);

    };


    var listNames = function(arr, extraLinkAttr) {

        var list = [];

        if (!arr || !arr.length) {
            return "";
        }

        if (extraLinkAttr) {
            extraLinkAttr = Y.Escape.html(Y.Lang.trim(extraLinkAttr)) + " ";
        } else {
            extraLinkAttr = "";
        }

        // console.log("listnames", arr);
        Y.Array.each(arr, function(item) {
            var entry = item.name;
            if (item.url) {
                entry = "<a " + extraLinkAttr + "href='" + Y.Escape.html(item.url) + "'>" + Y.Escape.html(entry) + "</a>";
            }
            list.push(entry);
        });

        return list.join(", ");
    };


    var listContacts = function(arr) {

        var list = [];

        if (!arr || !arr.length) {
            return "";
        }

        Y.Array.each(arr, function(contact) {
            var line, entry = [];
            line = contact.first_name + " " + contact.last_name;
            if (line.length > 1) {
                entry.push(Y.Escape.html(line));
            }

            line = wrapLink(contact.email_address, contact.email_address);
            if (line) {
                entry.push(line);
            }

            line = contact.phone_number;
            if (line) {
                entry.push(Y.Escape.html(line));
            }

            list.push(entry.join(", "));
        });

        return list.join("<br />");
    };


    var addBuildingURL = function(venue) {

        if (venue && venue.building_code  &&  !venue.url) {
            venue.url = "http://www.k-state.edu/maps/?show=" + venue.building_code;
        }

        return venue;
    };


    var addFriendly = function(event) {

        var room_sep,
            calendarurl = this.get(CALENDAR_URL_KEY) || "",
            imagebaseurl = this.get(IMAGE_BASE_URL_ATTR);

        if (!event) {
            return;
        }

        /*
         * Create a new property on the event named "friendly".  On that object, properties
         * are created with human-centric values derived from the real data on the event.
         */
        var friendly = {};

        /*
         * If the event started before ...
         */
        if (basedate===today_YYYYMMDD && event.start_date <= today_YYYYMMDD) {
            friendly.start_date = "Today";
            friendly.start_date_full = "Today";
        } else {
            friendly.start_date = humanizeDate(event.start_date);
            friendly.start_date_full = humanizeDate(event.start_date, true);
        }
        friendly.start_time = humanizeTime(event.start_time);
        friendly.start_datetime = Y.Lang.trim(friendly.start_date + " " + friendly.start_time);

        /*
         * If the end date equals the start date, omit the end date.
         */
        if (event.start_date !== event.end_date) {
            friendly.end_date = humanizeDate(event.end_date);
        } else {
            friendly.end_date = "";
        }
        friendly.end_time = humanizeTime(event.end_time);
        friendly.end_datetime = Y.Lang.trim(friendly.end_date + " " + friendly.end_time);

        /*
         * If the start time and end time are both either "a.m." or "p.m.", omit the start time's.
         */
        if ((friendly.start_datetime+friendly.end_datetime).match("([ap])\\.m\\..+\\1\\.\\m\\.")) {
            friendly.start_datetime = friendly.start_datetime.replace(/ [ap]\.m\./, "");
        }


        // friendly.description = truncateHTML(event.description, 130);

        friendly.audiences = listNames(event.audiences);
        friendly.areas = listNames(event.area);
        friendly.audiences = listNames(event.audiences);
        friendly.types = listNames(event.type);
        friendly.sponsors = listNames(event.sponsors);
        if (friendly.types && friendly.sponsors) {
            friendly.types_sponsors_sep = " / ";
        } else {
            friendly.types_sponsors_sep = "";
        }
        friendly.contacts = listContacts(event.contact_info);

        /*
         * The separator between the room and the building name is:
         *    "" unless both building and room are specified.
         *    " " if the room is a room number, e.g., "128 Dole Hall".
         *    ", " if the room is a name, e.g., "Forum Hall, K-State Student Union".
         */
        room_sep = "";
        if (!event.venue) {
            event.venue = {name: ""};
        }
        if (event.venue.name && event.room) {
            if (/^\s*\d+[A-Za-z]{0,5}$/.test(event.room)) {
                room_sep = " ";
            } else {
                room_sep = ", ";
            }
        }

        if (event.campus !== 'off') {
            event.venue = addBuildingURL(event.venue);
            friendly.venues = event.room + room_sep + wrapLink(event.venue.name, event.venue.url, "itemprop='url'");
        } else {
            friendly.venues = event.address;
        }

        /*
         * If there is something for both the start and end strings, then add a non-blank separator.
         */
        if ((friendly.start_date || friendly.start_time) && (friendly.end_date || friendly.end_time)) {
            friendly.datetime_sep = SEPARATOR;
        } else {
            friendly.datetime_sep = "";
        }
        if (friendly.start_date && friendly.end_date) {
            friendly.date_sep = SEPARATOR;
        } else {
            friendly.date_sep = "";
        }
        if (friendly.start_time && friendly.end_time) {
            friendly.time_sep = SEPARATOR;
        } else {
            friendly.time_sep = "";
        }

        if ((friendly.start_time || friendly.end_time) && friendly.venues) {
            friendly.datetime_venue_sep = ", ";
        } else {
            friendly.datetime_venue_sep = "";
        }

        friendly.url = event.url || (calendarurl + "?id=" + event.id + "&start=" + event.start_date + "&end=" + event.end_date);

        friendly.image = null;
        if (event.image) {
            friendly.image = event.image;
        }

        event.friendly = friendly;

        return event;
    };


    /*
     * If the host has a UL element, then the LI elements inside are what is replaced.
     * If the host does not have a UL element, then the host contents itself are replaced.
     * Presumably the host element itself is the UL element.
     */
    var setHostContent = function(html) {

        var host = this.get(HOST), eventcontainer;

        eventcontainer = host.one(UL) || host;

        eventcontainer.setHTML(html);
        eventcontainer.removeClass(LOADING_HIDDEN_CLASS);

        if (!this.get(SINGLE_EVENT_ATTR)) {
            if (eventcontainer.MoreToggle) {
                eventcontainer.MoreToggle.prepare();
            } else {
                eventcontainer.plug(Y.Plugin.MoreToggle);
            }
        }

    };


    /*
     * Include an event based on the title field.
     * If the title matches the specified string, interpreted as a regex, include the event.
     * Called with:
     *    this = the plugin
     *    parameter 1 = event
     *    parameter 2 = a string which is interpreted as a regular expression to match against the event title.
     * Return either the event (to include the event), or null (to exclude the event)
     */
    var filterIncludeTitle = function(event, titlematch) {

        var re;

        if (titlematch) {
            try {   // Protect in case the creation of the RegExp fails
                re = new RegExp(titlematch, "i");
                if (re.test(event.title)) {
                    return event;
                }
            }
            catch (ex) {
                /* Nothing -- assume no match */
            }

            return null;
        }

        return event;

    };


    /*
     * Exclude an event based on the title field.
     *
     * This just inverts the return from the filterIncludeTitle function.
     */
    var filterExcludeTitle = function(event, titlematch) {

       if (filterIncludeTitle(event, titlematch)) {
          return null;
       }

       return event;
    };


    /*
     * Exclude an event based on the type field.
     * If *any* of the types of this event match, exclude the event.
     * Called with:
     *    this = the plugin
     *    parameter 1 = event
     *    parameter 2 = the slug of the type to exclude
     * Return either the event (to include the event), or null (to exclude the event)
     */
    var filterExcludeType = function(event, typetoexclude) {

        var i;

        for (i = 0; i < event.type.length; i++) {
            if (event.type[i].slug === typetoexclude) {
                return null;
            }
        }

        return event;

    };


    var showSingleEvent = function(data) {

        var matchedevent, template, html, id = this.get(EVENT_ID_ATTR);

        console.log("show single", data);

        this.set(SINGLE_EVENT_ATTR, true);
        template = templateEngine.compile(SINGLE_EVENT_TEMPLATE);

        id = parseInt(id, 10);   /* Need to retrieve the event */
        matchedevent = Y.Array.find(data.results, function(event) {
            //console.log("evt", event);
            return event.id == id;
        });

        console.log(matchedevent);
        if (!matchedevent) {
            html = "<p>Event " + id + " not found.</p>";
        } else {
            matchedevent.singleevent = true;
            html = template(addFriendly.call(this, matchedevent));
        }

        setHostContent.call(this, html);

    };


    var wrapLink = function(html, url, extraLinkAttr) {

        html = html || "";

        if (html && url) {
            html = "<a href='" + url + "'" +
                   (extraLinkAttr ? " " + extraLinkAttr : "") +  ">" + html + "</a>";
        }

        return html;
    };


    var showEventList = function(data) {
        var i, html="", eventlist, groupby, rolluprecurring, events, event, eventgroup, template, unique, uniquekey, seen, headernav,
            dateheader, prevdateheader,
            dateheaderabbr, prevdateheaderabbr,
            omitprivate,
            filter,
            selectedcount,                            // Number of events actually selected
            displaycount,
            excludetitle = this.get(EXCLUDE_TITLE_ATTR),
            includetitle = this.get(INCLUDE_TITLE_ATTR),
            excludetype = this.get(EXCLUDE_TYPE_ATTR),
            sortorder = this.get(SORT_ORDER_ATTR),
            sortFn,
            eventid  = this.get(EVENT_ID_ATTR);

        if (!data) {
            data = this.get(DATA_ATTR);
        }

        /*
         * If this is a single-event retrieval, the format is different.
         */

        if (eventid) {
            showSingleEvent.call(this, data);
        }

        this.set(SINGLE_EVENT_ATTR, false);

        if (!data || !data.results) {
            html = "<p>Event list feed is currently unavailable.</p>";

        } else if (!data.results.length) {
            html = "<p>No events scheduled.</p>";

        } else {

            template = templateEngine.compile(TEMPLATE);

            filter = this.get(FILTER_ATTR);

            events = data.results;
            rolluprecurring = this.get(ROLLUPRECURRING_KEY);
            Y.Array.forEach(events, function(event) {
                if (rolluprecurring && event.start_date < basedate) {
                    event.recurring = true;
                    event.recurring_start_date = event.start_date;
                    event.recurring_start_time = event.start_time;
                }
            });

            sortFn = ascendingDate;
            if (sortorder === 'descending') {
                sortFn = descendingDate;
            }
            events = data.results.sort(sortFn);

            headernav = {};
            headernav.type = this.get(HEADER_NAV_ATTR);
            if (headernav.type) {
                headernav.label = "May 2013";    // !@#$%  This is not really used yet.
            }

            /*
             * Filter events and add the firstdate property to each event.
             */
            groupby = this.get(GROUPBY_KEY);
            eventlist = {
                groups: [],
                headernav: headernav,
                title: wrapLink(this.get(TITLE_KEY), this.get(CALENDAR_URL_KEY)),
                calendarurl: this.get(CALENDAR_URL_KEY),
                groupby: this.get(GROUPBY_KEY),
                dateheader: this.get(DATE_HEADER_ATTR)
            };
            omitprivate = !this.get(INCLUDEPRIVATE_ATTR);
            unique = this.get(UNIQUE_ATTR);
            seen = {};
            prevdateheader = null;
            prevdateheaderabbr = null;
            eventgroup = [];
            selectedcount = 0;
            displaycount = this.get(LIMIT_ATTR);
            //console.log("All events",events);
            for (i = 0; i < events.length  && selectedcount < displaycount; i++) {
                event = events[i];

                if (omitprivate && event['private']) {
                    continue;
                }

                if (typeof filter === 'function') {
                    event = filter.call(this, event);
                }

                if (excludetitle) {
                    event = filterExcludeTitle.call(this, event, excludetitle);
                }

                if (includetitle) {
                    event = filterIncludeTitle.call(this, event, includetitle);
                }

                if (excludetype) {
                    event = filterExcludeType.call(this, event, excludetype);
                }

                if (!event) {
                    continue;
                }

                if (unique) {
                    uniquekey = event.id + '--' + event.start_date + '--' + event.start_time + '--' + event.end_date + '--' + event.end_time;
                    if (seen[uniquekey]) {
                        continue;
                    }
                    seen[uniquekey] = 1;
                }

                // The event passes the filtering -- include it in the output
                selectedcount++;
                addFriendly.call(this, event);

                if (true || groupby) {              // Always true -- groupby various values is unimplemented
                    // Determine what the header for this event would be
                    dateheader = event.friendly.start_date_full;
                    dateheaderabbr = event.friendly.start_date;
                    if (rolluprecurring && event.start_date < basedate) {
                        dateheader = RECURRING_EVENTS_TITLE;
                        dateheaderabbr = RECURRING_EVENTS_TITLE;
                    }

                    // If this is the start of a new group, flush the previous group, if any
                    if (dateheader !== prevdateheader && eventgroup.length) {
                        eventgroup.title = prevdateheader;
                        eventgroup.titleabbr = prevdateheaderabbr;
                        eventlist.groups.push(eventgroup);
                        eventgroup = [];
                    }
                    prevdateheader = dateheader;
                    prevdateheaderabbr = dateheaderabbr;
                }

                eventgroup.push(event);
            }


            // If grouping, add the title for the last group.
            if (true || groupby) {          // Always true -- groupby various values is unimplemented
                eventgroup.title = prevdateheader;
                eventgroup.titleabbr = prevdateheaderabbr;
            }
            eventlist.groups.push(eventgroup);

            /*
            if (eventlist.groups[0].title === RECURRING_EVENTS_TITLE) {
                eventlist.groups[0].title = RECURRING_EVENTS_TITLE +
                 "<div class='ksu-el-hide-recurring'>- Hide " +
                 eventlist.groups[0].length + " recurring events</div>";
            }
            */
            console.log("eventlist", eventlist);

            html = template(eventlist);

            if (!html) {
                html = "<p>No events are available.</p>";
            }


        }

        setHostContent.call(this, html);
    };

    var handleEventList = function(data) {

        var calendarnav,
            slider,
            eventid  = this.get(EVENT_ID_ATTR);

        console.log("return from Pulse", data);

        this.set(DATA_ATTR, data);

        if (eventid) {
            showSingleEvent.call(this, data);
        } else {
            showEventList.call(this, data);
        }

        calendarnav = this.get(CALENDAR_NAV_WIDGET_KEY);
        if (calendarnav) {
            console.log("wiring up to a calendar navigation object");
            calendarnav.selectDates(new Date());
        }

        slider = this.get(HOST).hasPlugin("ListSlider");
        console.log("Found slider", slider);
        if (slider) {
            slider.initContents();
        }

    };

    /** retrieve new events from the web service
     *
     * Params is an object with the following properties:
     *    start - start date in the format "YYYYMMDD".  If omitted, today
     *            is used.
     */
    var retrieveEvents = function(url) {

        var request, eventid, data;

        eventid = this.get(EVENT_ID_ATTR);
        if (eventid) {
            data = this.get(DATA_ATTR);
            if (data) {
                console.log("Got data");
                handleEventList.call(this, data);
                return;
            }
        }
        console.log("Retrieving");

        request = new Y.JSONPRequest(url, {on: {success: handleEventList}, format: buildURL, context: this});
        request.send(this);

    };


    var getNextChunk = function() {


    };

    var handleHistoryChange = function(evt, plugin) {

        var id;

        console.log("Handling history change", this, arguments);

        try {
            id = evt.changed.id.newVal;
        } catch(ex) {
            id = null;
        }

      plugin.render();

    };


    var isHidden = function(content) {

        return content.hasClass(CONTENT_CLOSED_CLASS);

    };


    var show = function(content, callback) {

        var fullheight = content.one('*').getComputedStyle('height');

        if (content.hasClass(CONTENT_TRANSITIONING_CLASS)) {
            return;
        }

        content.transition({
            duration: TRANSITION_DURATION,
            easing: 'ease-in-out',
            height: fullheight,
            on: {
                start: function() {
                    content.removeClass(CONTENT_CLOSED_CLASS);
                    content.addClass(CONTENT_TRANSITIONING_CLASS);
                },
                end: function() {
                    content.removeClass(CONTENT_TRANSITIONING_CLASS);
                    content.addClass(CONTENT_OPEN_CLASS);
                    if (typeof callback === 'function') {
                        callback.call(content);
                    }
                }
             }
        });
    };


    var hide = function(content, callback) {

        if (content.hasClass(CONTENT_TRANSITIONING_CLASS)) {
            return;
        }

        content.transition({
            duration: TRANSITION_DURATION,
            easing: 'ease-in-out',
            height: '0px',
            on: {
                start: function() {
                    content.removeClass(CONTENT_OPEN_CLASS);
                    content.addClass(CONTENT_TRANSITIONING_CLASS);
                },
                end: function() {
                    content.removeClass(CONTENT_TRANSITIONING_CLASS);
                    content.addClass(CONTENT_CLOSED_CLASS);
                    if (typeof callback === 'function') {
                        callback.call(content);
                    }
                }
            }
        });

    };


    var toggleRecurring = function(on, content, callback) {

        var target, href, id, arr;

        if (typeof on !== 'boolean') {
            callback = content;
            content = on;
            on = isHidden(content);
        }

        if (on) {
            show(content, callback);
        } else {
            hide(content, callback);
        }

    };


    var setRecurringLabel = function(content, target) {
        var data = {hidden: isHidden(content), count: content.all('li').size()},
            template =
                "<% if (data.hidden) { %>" +
                    "+ Show <% } else { %>- Hide <% } %>" +
                "<%= data.count %> recurring events";

            target.setHTML(templateEngine.render(template, data));

    };


    var handleToggleRecurring = function(evt) {

        var target, content, template;
        target = evt.currentTarget;

        content = target.ancestor().next();
        toggleRecurring(content,
            function() {
                setRecurringLabel(content, target);
        });

    };


    var handleNavigation = function(evt) {

        var target, href, calendarurl, id, startdate;

        target = evt.currentTarget;

        console.log("Nav", this, evt, target);

        id = target.getAttribute("data-ksu-eventid");
        if (!id) {
            return;
        }

        if (evt.altKey && evt.shiftKey && (evt.ctrlKey || evt.metaKey)) {
            window.open(this.get(HOSTNAME_ATTR) + "/admin/calendar/event/" + id + "/", "_blank");
            evt.preventDefault();
            return;
        }

        href = target.getAttribute("href");
        calendarurl = this.get(CALENDAR_URL_KEY) || '?';
        if (!href.startsWith(calendarurl)) {
            return;
        }

        if (target.ancestor(DOT+SIDEBAR_SECONDARY_CLASS)) {
            return;
        }

        startdate = target.getAttribute("data-ksu-event-startdate");
        history.add({id: id, start: startdate}, {title: "Event", url: "?id=" + id + "&start=" + startdate});
        evt.preventDefault();
   };


    /**
     * Handle a date selection event from the calendar navigation aid.
     *
     * When a user selects a day in the navigation aid, this method is used to
     * change the widget's start date and re-render the page.
     */
    var handleCalendarNav = function(evt) {
        var startdate;

        console.log("handleDateClick2", this, arguments);

        startdate = getYYYYMMDD(evt.date);
        this.set(START_ATTR, startdate);
        history.add({id: null, start: startdate}, {title: "Event List", url: "?start=" + startdate});

   };


    /**
     * Convert a human-specified string into a boolean value.
     *
     * The returned value will be true if the passed argument
     * is "yes", "true", or "on", in any case, and potentially with
     * leading and trailing blanks.
     *
     */
    var forceBoolean = function(val) {

        return (/^\s*(yes|true|on)\s*$/i).test(val);

    };


    /*
     * If the calendar navigation widget has been added to the page, then
     * wire up an event handler to react to date changes.
     */
    var setCalNavWidget = function(widget) {
        if (widget) {
            widget.after("dateClick", handleCalendarNav, this);
        }
    };


    /* EventList class constructor */
    var EventList = function(config) {
        /* Initialize the plugin infrastructure.  This calls the initializer
         * method on the new instance.
         */
        EventList.superclass.constructor.apply(this, arguments);
    };

    /*
     * Required NAME static field, to identify the class and
     * used as an event prefix, to generate class names etc. (set to the
     * class name in camel case).
     */
    EventList.NAME = "EventList";

    /*
     * Required NS static field, to identify the property on the host which will,
     * be used to refer to the plugin instance ( e.g. host.EventList.doSomething() )
     */
    EventList.NS = "EventList";

    /*
     * The attributes for the plugin.
     */
    EventList.ATTRS = {
        audience: {},
        baseurl: {
            value: "/calendar/api/v3/event/"
        },
        calendar: {},
        calendarnavwidget: {
            setter: setCalNavWidget
        },
        calendarurl: {},
        data: {},
        dateheader: {
            value: false,
            setter: forceBoolean
        },
        days: {
            value: 31
        },
        end: {},
        eventid: {},
        excludetitle: {
           value: null
        },
        includetitle: {
           value: null
        },
        excludetype: {
           value: null
        },
        filter: {},
        groupby: {
            value: null
        },
        headernav: {
            value: null    /* Or "", "month" or "day" */
        },
        hostname: {
            value: "//pulse.k-state.edu"
        },
        imagebaseurl: {
            value: "https://s3.amazonaws.com/ksu_webteam/"
        },
        limit: {
            value: 20
        },
        includeprivate: {
            value: true,
            setter: forceBoolean
        },
        rolluprecurring: {
            value: false,
            setter: forceBoolean
        },
        sidebarcalendar: {
            value: false,
            setter: forceBoolean
        },
        singleevent: {
            value: false,
            setter: forceBoolean
        },
        sortorder: {},
        start: {},
        template: {},
        title: {
            value: "Events"
        },
        type: {},
        unique: {
            value: true
        },
        venue: {}
   };


    /* EventList extends the base Plugin.Base class */
    Y.extend(EventList, Y.Plugin.Base, {
        initializer: function(config) {
            var host = this.get(HOST), sb, addedwidget=null;

            console.log("Initializing", this.name);
            today_YYYYMMDD = getToday();

            templateEngine = new Y.Template();

            this.render();

            history = new Y.History();
            host.delegate("click", handleNavigation, "a", this);
            host.delegate("click", handleToggleRecurring, ".ksu-el-toggle-recurring");
            history.after("change", handleHistoryChange, history, this);   // Pass the EventList plugin reference to the handler.

            /*
             * If a calendar navigation widget was requested, add it to the page
             */
            if (this.get(SIDEBAR_CALENDAR_KEY)) {
                console.log("Adding a sidebar calendar nav");
                sb = $(DOT+SIDEBAR_SECONDARY_CLASS);
                if (sb) {
                    var temp = Y.Node.create("<div></div>");
                    sb.prepend(temp);
                    addedwidget = new Y.Calendar({
                        contentBox: temp,
                        width: '100%',
                        showPrevMonth: true,
                        showNextMonth: true
                    }).render();
                }
             }

             if (addedwidget) {
                 this.set(CALENDAR_NAV_WIDGET_KEY, addedwidget);
             }
             console.log("initialization complete", this.name);
         },


        /**
         * Display the event list.
         *
         * This function is called once by the initializer.  However, if options change
         * after the initial display, then the render method must be called to update
         * the event list on the page to reflect the updated options.
         */
        render: function() {

            var host = this.get(HOST),
                request = Y.QueryString.parse(window.location.search.replace(/^\?/, ""));

            console.log(this.name, "render");

            host.setHTML(LOADING_HTML);

            // Let the values specified on the URL override, but only if
            // a value was actually specified.
            if (request.id) {
                this.set(EVENT_ID_ATTR, request.id);
            }

            basedate = request.start || getToday();
            this.set(START_ATTR, basedate);

            retrieveEvents.call(this);

        }


    });

    Y.namespace("Plugin").EventList = EventList;


}, '2.0.0', {
    "requires": [
        "node",
        "event",
        "array-extras",
        "plugin",
        "querystring-parse-simple",
        "io-base",
        "json-parse",
        "jsonp",
        "jsonp-url",
        "template",
        "history",
        "datatype-date-format",
        "calendar",
        "transition"
    ]
});
